import { z } from "zod";

// ==================
// Enums
// ==================

/** Valid Shopify plan types */
export const ShopifyPlanEnum = z.enum(["basic", "shopify", "advanced", "plus"]);
export type ShopifyPlan = z.infer<typeof ShopifyPlanEnum>;

// ==================
// Store Schema
// ==================

/** Store object returned from the API */
export const ClientStoreSchema = z.object({
    id: z.number().int().positive(),
    url: z.string(),
    title: z.string(),
    shopify_plan: ShopifyPlanEnum.nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});

export type ClientStore = z.infer<typeof ClientStoreSchema>;

